import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeSwitcherService } from './core/themes/theme-switcher.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`,
  styles: `
    :host {
      display: block;
      height: 100%;
    }
  `,
})
/** Root application shell that hosts routed views. */
export class AppComponent {
  /** Ensures theme is applied on app bootstrap. */
  private readonly themeSwitcher = inject(ThemeSwitcherService);
}
